import script from "./practice-empty-pending.vue?vue&type=script&setup=true&lang=js"
export * from "./practice-empty-pending.vue?vue&type=script&setup=true&lang=js"

import "./practice-empty-pending.vue?vue&type=style&index=0&id=52726ea2&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52726ea2"]])

export default __exports__